import { useTranslation } from "features/translations";
import { Action, Heading3, RenderIf } from "shared/components";
import { VIEW_MODES } from "shared/contexts/ViewMode";

import { ButtonAdd } from "../ButtonAdd";
import { useWidgetContent } from "../Content064.context";
import styles from "./DefaultBlock.module.scss";

export const DefaultBlock = ({}) => {
  const { t } = useTranslation();
  const { courses, onSelectCourse } = useWidgetContent();

  return (
    <div className={styles.wrapper}>
      <div className={styles.blocks}>
        <Heading3 className={styles.title} color="bold" appearance="bold">
          {t("default")}
        </Heading3>
        <RenderIf viewMode={VIEW_MODES.DESKTOP}>
          <div className={styles.list}>
            {courses.map(({ id, title, slug }) => (
              <Action key={id} onClick={onSelectCourse(slug)}>
                <Heading3
                  className={styles.item}
                  color="dark"
                  appearance="bold"
                >
                  {title}
                </Heading3>
              </Action>
            ))}
          </div>
        </RenderIf>
        <RenderIf viewMode={VIEW_MODES.MOBILE}>
          <ButtonAdd />
        </RenderIf>
      </div>
    </div>
  );
};
